const headless = {
  url: "https://shasamx.myshopify.com/api/2024-07/graphql.json",
  hash: "a8ea2c7f8c33041181cc09f1d64b35c5",
  fetch: async (query) => {
    const request = {
      async: true,
      crossDomain: true,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": headless.hash,
        "Content-Type": "application/graphql",
      },
      body: query,
    };
    const response = await fetch(headless.url, request);
    const res = await response.json();
    if (res.data?.nodes) return res.data.nodes;
    else if (res.data) return res.data;
    else return res;
  },
};
const cart = {
  drawer: null,
  add: (variantId, productId, attributionKey) => {
    let formData = {
      id: variantId,
      quantity: 1,
      sections: cart.drawer.getSectionsToRender().map((section) => section.id),
    };
    fetch(routes.cart_add_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then(async (response) => {
        cart.drawer.renderContents(response)
        
        if (attributionKey) {
          // Atribución del quick-buy
          nostojs(api => {
            api.recordAttribution({
              type: "cp",
              target: String(productId),
              ref: String(attributionKey),
              refType: "api"
            }).done();
          });

          const newCart = await getCurrentCart();
          const currencyCode = newCart?.currency || newCart?.attributes?.currency || "MXN";

          nostojs(api => {
            api.defaultSession()
              .setCart({
                items: (newCart.items || []).map(item => ({
                  product_id: String(item.product_id),
                  sku_id: String(item.sku),
                  quantity: Number(item.quantity),
                  unit_price: Number(item.price) / 100,
                  price_currency_code: String(currencyCode)
                }))
              })
              .viewCart()
              .update();
          });
          console.log('Atribución hecha')
        }
        ncaddToken()
        uploadCart()
        executeInCartUpdate()
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
};
class Card {
  constructor(id, container, source, attributionKey, useParent, parent) {
    this.id = id;
    this.container = document.getElementById(container);
    this.containerId = container
    this.source = source;
    this.attributionKey = attributionKey ? `?nosto=${attributionKey}` : "";
    this.carousel = attributionKey || "";
    this.useParent = useParent
    this.parent = parent
    this.create();
  }
  async create() {
    const query = `
      query {
        product(id: "gid://shopify/Product/${this.id}") {
          gid: id
          title
          list: metafield(namespace: "custom", key: "product_list") {
            value
          }
          color: metafield(namespace: "custom", key: "color") {
            value
          }
        }
      }
    `;
    const { product } = await headless.fetch(query);
    if (product && product.gid) {
      product.id = product.gid.split("/").at(-1);
      if(!product.list){
        product.list = { value: JSON.stringify([product.gid]) };
      }
      const query = `
        query {
          nodes(ids: ${product.list.value}) {
            ... on Product {
              id
              onlineStoreUrl
              color: metafield(namespace: "custom", key: "color") {
                value
              }
              images(first: 1) {
                edges {
                  node {
                    url
                    altText
                  }
                }
              }
              collections(first: 15) {
                edges {
                  node {
                    id
                    handle
                    title
                  }
                }
              }
              variants(first: 20) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    quantityAvailable
                    price{
                      amount
                    }
                    compareAtPrice{
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      `;
      const productList = await headless.fetch(query);
    //Caso especial para gift card
    if(String(product.id) === '8700344402132'){
      const giftCard = productList[0]
      const card = document.createElement("div");
      card.className = "card";
      card.innerHTML = `
        <div>
            <label class="card-product giftcard-card">
              <input type="radio" class="hidden" id="${this.carousel}-${product.id}" name="${this.carousel}-${product.id}">
              <a
              ${this.source === "nostosearch"
              ? `href="${giftCard.onlineStoreUrl}?&fromnostosearch=true" onclick="window.recordClick('${product.id}', '${giftCard.onlineStoreUrl}')"`
              : `href="${giftCard.onlineStoreUrl}${this.attributionKey}"`
              }>
                <img loading="lazy" src="${giftCard.images.edges[0].node.url}&width=600" alt="${product.title}" />
                <div class="card-title">${product.title}</div>
                <div class="flex price-container">
                  <p>$${giftCard.variants.edges[0].node.price.amount}0 - $${giftCard.variants.edges[giftCard.variants.edges.length - 1].node.price.amount}0</p>
                </div>
              </a>
            </label>
        </div>
      `;
      if(this.useParent){
        const parentId = this.parent.replace(/^#/, '');
        const containerId = this.containerId.replace(/^#/, '');

        const parentEl = document.getElementById(parentId);

        const containerEl = parentEl.querySelector(`[id="${containerId}"]`);

        containerEl.appendChild(card);
      }
      else{
        this.container.appendChild(card);
      }
      return
    }
      const productColors = [];
      for (const product of productList) {
        if (product && product.images.edges.length > 0) {
          const masVendido = product.collections?.edges?.some(c => c.node.handle === "buen-fin-shasa") || false;
          const compareAtPrice = product.variants.edges[0].node.compareAtPrice?.amount;
          const productDetails = {
            id: product.id.split("/").at(-1),
            color: product.color.value,
            class: product.color.value
              .trim()
              .replace(/[^a-zA-Z]/g, "")
              .toLowerCase(),
            image: product.images.edges[0].node.url,
            url: product.onlineStoreUrl,
            price: product.variants.edges[0].node.price.amount,
            compareAtPrice: compareAtPrice ? `$${compareAtPrice}0` : "",
            variants: product.variants.edges
              .map((variant) => {
                return {
                  title: variant.node.title,
                  id: variant.node.id.split("/").at(-1),
                  availableForSale: variant.node.availableForSale,
                };
              })
              .filter((variant) => variant.availableForSale),
            tagMasVendido: masVendido,
            stock: product.variants?.edges?.reduce((s, v) => s + (v.node.quantityAvailable || 0), 0) || 0,
          };
          if (compareAtPrice) {
            productDetails.discount = Math.ceil(100-((productDetails.price / compareAtPrice) * 100))
          }
          productColors.push(productDetails);
        }
      }
      // //Put the current color first
      if (productColors.length > 1) {
        const index = productColors.findIndex(
          (p) => p.color == product.color.value
        );
        productColors.unshift(productColors.splice(index, 1)[0]);
      }
      const card = document.createElement("div");
      const isLoggedIn = !!(window.wishlist_parse && window.wishlist_parse.items);
      card.className = "card";
      card.innerHTML = `
        <div>
          ${productColors.map((productColor) => `
            <label class="card-product ${productColor.stock} ${productColor.variants.length === 0 ? "unavailable" : ""}">
            ${productColor.tagMasVendido ? `<div class="product-badge-vendidos-plp">
                                              <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.68 20.08">
                                                <defs>
                                                  <style>
                                                    .cls-1_mas_vendidos {
                                                      letter-spacing: -.02em;
                                                    }

                                                    .cls-2_mas_vendidos {
                                                      fill: #6e6e6d;
                                                      font-family: Montserrat-Bold, Montserrat;
                                                      font-size: 10px;
                                                      font-weight: 700;
                                                    }

                                                    .cls-3_mas_vendidos {
                                                      fill: #e5e5da;
                                                    }
                                                  </style>
                                                </defs>
                                                <path class="cls-3_mas_vendidos" d="M2.22,0h82.24C85.68,0,86.68.99,86.68,2.22v17.87H0V2.22C0,.99.99,0,2.22,0Z"></path>
                                                <text class="cls-2_mas_vendidos" transform="translate(4.96 13.22)"><tspan x="0" y="0">MÁS </tspan><tspan class="cls-1_mas_vendidos" x="26.42" y="0">V</tspan><tspan x="33.73" y="0">ENDIDO</tspan></text>
                                              </svg>
                                            </div>` : ``}
              ${!productColor.tagMasVendido && productColor.stock < 4 ? `<div class="product-badge-vendidos-plp pocas_piezas_value-plp">
                                                                          <!--?xml version="1.0" encoding="UTF-8"?-->
                                                                          <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86.68 20.08">
                                                                            <defs>
                                                                              <style>
                                                                                .cls-1_piezas {
                                                                                  letter-spacing: .01em;
                                                                                }

                                                                                .cls-2_piezas {
                                                                                  letter-spacing: 0em;
                                                                                }

                                                                                .cls-3_piezas {
                                                                                  fill: #d31216;
                                                                                }

                                                                                .cls-4_piezas {
                                                                                  fill: #fff;
                                                                                  font-family: Montserrat-Medium, Montserrat;
                                                                                  font-size: 10px;
                                                                                  font-weight: 500;
                                                                                }

                                                                                .cls-5_piezas {
                                                                                  letter-spacing: 0em;
                                                                                }
                                                                              </style>
                                                                            </defs>
                                                                            <path class="cls-3_piezas" d="M2.22,0h82.24C85.68,0,86.68.99,86.68,2.22v17.87H0V2.22C0,.99.99,0,2.22,0Z"></path>
                                                                            <text class="cls-4_piezas" transform="translate(4.66 12.98)"><tspan class="cls-1_piezas" x="0" y="0">PO</tspan><tspan class="cls-2_piezas" x="15.88" y="0">C</tspan><tspan class="cls-1_piezas" x="23.07" y="0">AS </tspan><tspan class="cls-5_piezas" x="39.68" y="0">P</tspan><tspan class="cls-1_piezas" x="46.93" y="0">IEZAS</tspan></text>
                                                                          </svg>
                                                                        </div>` : ``}
              <input type="radio" class="hidden" id="${this.carousel}-${productColor.class}-${product.id}" name="${this.carousel}-${product.id}" value="${productColor.color}" ${productColor.color == product.color.value ? "checked" : ""}>
              <a
              ${this.source === "nostosearch"
              ? `href="${productColor.url}?&fromnostosearch=true" onclick="window.recordClick('${productColor.id}', '${productColor.url}')"`
              : `href="${productColor.url}${this.attributionKey}"`
              }>
                <img loading="lazy" src="${productColor.image}&width=600" alt="${product.title}" />
                <div class="card-title">${product.title}</div>
                <div class="flex price-container">
                  ${ productColor.compareAtPrice ? `
                  <p style="color:red;">$${productColor.price}0</p>
                  <p><del>${productColor.compareAtPrice}</del></p>
                  ` : `
                  <p  style="color:red;">$${(productColor.price*0.85).toFixed(2)}</p>
                  <p><del>$${productColor.price}0</del></p>
                  `
                  }
                </div>
              </a>
              <div class="wishlist-btn-wrap">
                ${buildWishlistButton({ product, productColor, isLoggedIn })}
              </div>
              <div class="size-container flex justify-center">
                ${productColor.variants.length === 0 ? 
                  "<div class='size'><b>AGOTADO</b></div>" :
                  productColor.variants.map((variant) => {
                    const isUniqueSize = variant.title === "UNITALLA" || variant.title === "SIN TALLA";
                    const extraClass = isUniqueSize ? " pixel_width--large" : "";
                    return `<div class="size pixel_width${extraClass}" onclick="cart.add(${variant.id},${this.id},'${this.attributionKey.replace('?nosto=','')}')">${variant.title}</div>`;
                  }).join("")
                }
              </div>
              ${productColor.discount ? `
                <div class="discount-label sale">-${productColor.discount}%</div>
              ` : `
                <div class="discount-label event">
                  <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0676/3433/1860/files/BUEN_FIN_SHASA_BF_6f8bc70b-7d71-4ca4-af54-5df676d25a0b.svg?v=1763003346" alt="Buen Fin">
                </div>
              `}
            </label>
          `).join("")}
        </div>
        <div class="swatch-container flex">
          ${
            this.source === "nostosearch"
              ? (() => {
                  const first = productColors.slice(0, 5)
                    .map((productColor) =>
                      `<label class="swatch swatch-${productColor.class}" for="${this.carousel}-${productColor.class}-${product.id}"></label>`
                    )
                    .join("");
                  const rest = Math.max(productColors.length - 5, 0);
                  return first + (rest > 0 ? `<span class="swatch-more">${rest}+</span>` : "");
                })()
              : productColors
                  .map((productColor) =>
                    `<label class="swatch swatch-${productColor.class}" for="${this.carousel}-${productColor.class}-${product.id}"></label>`
                  )
                  .join("")
          }

        </div>
      `;
      // console.log('CONTAINER')
      // console.log(this.container)

      if(this.useParent){
        const parentId = this.parent.replace(/^#/, '');
        const containerId = this.containerId.replace(/^#/, '');

        const parentEl = document.getElementById(parentId);

        const containerEl = parentEl.querySelector(`[id="${containerId}"]`);

        containerEl.appendChild(card);
      }
      else{
        this.container.appendChild(card);
      }
    }
  }
}
window.addEventListener("load", () => {
  cart.drawer = document.querySelector("cart-drawer");
});


function getHandleFromUrl(url) {
  try {
    const afterProducts = url.split('/products/')[1] || '';
    return afterProducts.split('?')[0].replace(/\/$/, '');
  } catch { return ''; }
}

// Helper: arma el <button> wishlist con todos los data-*
function buildWishlistButton({ product, productColor, isLoggedIn }) {
  // Primer variant para data-wishlist__variant (si existe)
  const firstVariantId = (productColor.variants && productColor.variants[0])
    ? productColor.variants[0].id
    : '';

  // URL absoluta al producto (como hacía Liquid con shop.url + product.url)
  const productUrl = productColor.url;

  // Image URL ~600x600 (equivalente a | img_url: '600x600')
  const imageUrl = `${productColor.image}&width=600&height=600&crop=center`;

  // Categorías: si no las tienes en JS, deja vendor o vacío
  const categories = Array.isArray(product.collections)
    ? product.collections.map(c => c.title).join(',')
    : (product.vendor || '');

  // Click según login
  const onClick = isLoggedIn ? 'js_wishlist__add(this)' : 'js_wishlist__account()';

  return `
    <button
      class="c-button-wishlist cutom-wish-button"
      aria-label="Add to wishlist"
      onclick="${onClick}"
      data-wishlist__active="false"
      data-wishlist__id="${product.id}"
      data-wishlist__variant="${firstVariantId}"
      data-wishlist__handle="${getHandleFromUrl(productUrl)}"

      data-productname="${String(product.title).replace(/"/g, '&quot;')}"
      data-productid="${product.id}"
      data-producturl="${productUrl}"
      data-imageurl="${imageUrl}"
      data-price="${productColor.price}" 
      data-categories="${categories}"
    >
      <svg aria-hidden="true" focusable="false" fill="none" stroke-width="" width="24" class="" viewBox="0 0 24 24"> <path clip-rule="evenodd" d="m12 21.844-9.588-10a5.672 5.672 0 0 1-1.063-6.551v0a5.673 5.673 0 0 1 9.085-1.474L12 5.384l1.566-1.565a5.673 5.673 0 0 1 9.085 1.474v0a5.673 5.673 0 0 1-1.062 6.548L12 21.844Z" stroke="currentColor" stroke-linecap="round" fill="none" stroke-linejoin="round" stroke-width="2"></path> </svg>
    </button>
  `;
}